import { Link, useParams, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { api } from '../../lib/supabase';
import { Loader2 } from 'lucide-react';

export default function MobileFinishPending() {
  const { id } = useParams();
  const nav = useNavigate();
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const i = setInterval(() => setProgress((p) => Math.min(p + 7, 100)), 250);
    return () => clearInterval(i);
  }, []);

  // After verification "completes", auto-redirect based on participation state
  useEffect(() => {
    if (progress < 100) return;
    let cancelled = false;
    (async () => {
      const part = await api.getMyParticipation(id);
      if (cancelled) return;
      const status = part?.state === 'verified' ? 'verified' : part?.state === 'unverified' ? 'unverified' : null;
      if (status) nav(`/events/${id}/result?status=${status}`, { replace: true });
    })();
    return () => { cancelled = true; };
  }, [progress, id, nav]);

  return (
    <div className="px-4 pt-8 pb-6 min-h-full flex flex-col items-center justify-center text-center space-y-6" data-testid="finish-pending">
      <Loader2 className="h-12 w-12 animate-spin text-primary" />
      <div>
        <h1 className="font-display text-3xl font-bold tracking-tight">You finished!</h1>
        <p className="text-sm text-muted-foreground mt-2">Verifying your run...</p>
      </div>

      <div className="rivl-card p-4 w-full max-w-xs space-y-3">
        <div className="h-1.5 bg-secondary rounded-full overflow-hidden">
          <div className="h-full bg-primary transition-all" style={{ width: `${progress}%` }} />
        </div>
        <div className="rivl-label text-[9px]">Cross-checking GPS · checkpoints · timing</div>
      </div>

      <div className="grid grid-cols-2 gap-3 w-full max-w-xs">
        <Link to={`/events/${id}/result?status=verified`} className="rivl-card py-3 text-center text-sm font-medium hover:border-primary" data-testid="finish-go-verified">
          (demo) Verified
        </Link>
        <Link to={`/events/${id}/result?status=unverified`} className="rivl-card py-3 text-center text-sm font-medium hover:border-primary" data-testid="finish-go-unverified">
          (demo) Unverified
        </Link>
      </div>
    </div>
  );
}
